import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8.874 13.9a.475.475 0 0 0 .475-.475V4.27a.475.475 0 1 0-.95 0v9.155c0 .262.213.474.475.474",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M3.826 8.843c0-.263.212-.475.474-.475h9.155a.475.475 0 1 1 0 .95H4.3a.475.475 0 0 1-.474-.475",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8.86 16.77a7.91 7.91 0 1 0 0-15.82 7.91 7.91 0 0 0 0 15.82m0 .949A8.86 8.86 0 1 0 8.86 0a8.86 8.86 0 0 0 0 17.719",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }